import React from 'react';
import classNames from 'classnames';

import css from './IconEye.module.css';

/**
 * Open eye icon, shown when a password can be revealed.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @param {string?} props.ariaLabel accessible label for the icon
 * @returns {JSX.Element} SVG icon
 */
const IconEye = props => {
  const { className, rootClassName, ariaLabel } = props;
  const classes = classNames(rootClassName || css.root, className);
  const roleInfo = ariaLabel ? { role: 'img', 'aria-label': ariaLabel } : { 'aria-hidden': 'true' };

  return (
    <svg
      className={classes}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...roleInfo}
    >
      <path
        d="M1.333 8C2.222 5.556 4.667 3.333 8 3.333S13.778 5.556 14.667 8C13.778 10.444 11.333 12.667 8 12.667S2.222 10.444 1.333 8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="2" stroke="currentColor" />
    </svg>
  );
};

export default IconEye;
